<template lang="pug">
section#article-page.section.page-section.top-section
  spinner(v-if="settings.loading")
  div(v-else)
    .header(:style="`background-image:url(${backgroundUrl})`")
      .container
        h1.is-size-1 {{ article.title }}
        .meta
          .author
            speaker-tag(:value="article._embedded.author")
          .date {{ article.pub_date | date('dddd MMMM DD, YYYY') }}
        p.is-size-5.has-text-grey-light {{ article.short_desc | truncate(descLength) }}
    section.section.page-section
      .container
        //- .article-meta
        //-   div {{ article._embedded.author.full_name }}
        //-   div {{ article.pub_date | date('dddd MMMM DD, YYYY') }}
        //-   div
        //-     b-icon(icon="facebook")
        //-     b-icon(icon="twitter")
        //-     b-icon(icon="pinterest")
        //-     //- social-links(:value="account.social")
        .article-body.is-size-5-desktop
          .content.mobile-padding(v-html="compiledBody")
</template>

<script>
import { mapGetters } from 'vuex';
import cloudinary from 'cloudinary-core';
import marked from 'marked';
import ArticleListItem from '@/components/articles/ArticleListItem.vue';
import SocialLinks from '@/components/SocialLinks.vue';
import SpeakerTag from '@/components/speakers/SpeakerTag.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'article-page',
  components: {
    ArticleListItem,
    SocialLinks,
    SpeakerTag,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      article: getterTypes.GET_ARTICLE,
    }),
    backgroundUrl() {
      if (!this.article._embedded.artwork) return null;
      let opts = {};
      if (this.isMobile) {
        opts = {
          width: 600,
          height: 600,
          effect: 'blur:700',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'thumb',
          opacity: 30,
          format: 'png',
        };
      } else {
        opts = {
          width: 2000,
          height: 700,
          effect: 'blur:700',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'fill',
          opacity: 30,
          format: 'png',
        };
      }
      return this.cloudinary.url(this.article._embedded.artwork.cl_id, opts);
    },
    compiledBody() {
      if (this.article.id === undefined || !this.article.body) return null;
      return marked(this.article.body);
    },
    descLength() {
      return this.isMobile ? 100 : 250;
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
  },
  created() {
    this.cloudinary = cloudinary.Cloudinary.new({
      cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
    });
    this.getPage();
  },
  data() {
    return {
      cloudinary: null,
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getPage() {
      this.settings.loading = true;
      const payload =  {
        id: this.id,
        zoom: 'artwork,author',
      };
      await this.$store.dispatch(actionTypes.DO_GET_ARTICLE, payload);
      this.settings.loading = false;
    },
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  watch: {
    $route: 'getPage',
  },
};
</script>

<style lang="scss">
#article-page {
  .header {
    @include hero;
  }
  .page-section {
    .article-heading {
      padding: 1.5rem 0;
    }
    .article-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid $grey-lighter;
      border-bottom: 1px solid $grey-lighter;
      color: $grey-light;
      padding: 0.75rem 0;
      margin: 1.5rem 0 3.5rem;
    }
    .content {
      // background-color: $white;
      // padding: 1.5rem;
      h1, h2, h3, h4, h5, h6, b, strong {
        font-weight: 500 !important;
      }
      img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
      }
      line-height: 175%;
    }
  }
}

@media (min-width: $desktop) {
  #article-page {
    .page-section {
      .article-body {
        padding: 2.5rem 0;
        .content {
          max-width: 65%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
